<section class="section-white" *ngIf="benefitsData">
  <div class="section-container">
    <div class="align-c">
      <h2
        class="section-heading mar-b-48 wid-50 align-c"
        *ngIf="benefitsData?.title"
      >
        {{ benefitsData?.title }}
      </h2>
    </div>
    <div
      class="section-description mar-b-48 align-c"
      *ngIf="benefitsData?.paragraph"
    >
      <div class="wid-75" [innerHtml]="benefitsData?.paragraph | toHtml"></div>
    </div>
    <div class="benefit-your-clients benefit-partner">
      <div class="benefit-your-clients-content white">
        <!----- Proactive security measures ----->
        <div *ngFor="let card of benefitsData?.component1">
          <img
            src="{{ card?.fields?.imageicon?.fields?.file?.url }}"
            alt="{{ card?.fields?.imageicon?.fields?.title }}"
          />
          <div class="security-compliance-heading">
            {{ card?.fields?.title }}
          </div>
          <div
            class="security-compliance-description"
            [innerHtml]="card?.fields?.description | toHtml"
          ></div>
        </div>
      </div>
      <img
        loading="lazy"
        src="{{ benefitsData?.image?.[0]?.fields?.file?.url }}"
        alt="{{ benefitsData?.image?.[0]?.fields?.file?.title }}"
        class="wid-full"
      />
    </div>
  </div>
</section>
